<template>
  <div>
    <div
      class="mb-md"
      v-if="
        type == CUSTOMIZE_FIELD_TYPE_AUDIO_OR_SEARCH_SONG ||
        type == CUSTOMIZE_FIELD_TYPE_SEARCH_SONG
      "
    >
      <sib-select
        size="md"
        :options="
          type == CUSTOMIZE_FIELD_TYPE_AUDIO_OR_SEARCH_SONG
            ? options
            : searchOptions
        "
        :value="optionSelected"
        @input="changeOption"
      ></sib-select>
    </div>
    <div
      v-if="
        type == CUSTOMIZE_FIELD_TYPE_AUDIO_OR_SEARCH_SONG ||
        type == CUSTOMIZE_FIELD_TYPE_AUDIO
      "
      v-show="
        optionSelected == AUDIO_BUTTON || type == CUSTOMIZE_FIELD_TYPE_AUDIO
      "
    >
      <div
        class="sib-form-item__label"
        v-if="type == CUSTOMIZE_FIELD_TYPE_AUDIO_OR_SEARCH_SONG"
      >
        {{ labelAudio || 'Your Audio' }}
      </div>
      <FileUpload
        v-bind="{
          id,
          text,
          accept,
          multiple,
          required: optionSelected == AUDIO_BUTTON,
          onChange,
        }"
      ></FileUpload>
      <FileUploadList v-bind="{ hideProperties: true, fileList, onDelete }">
      </FileUploadList>
      <template
        v-if="
          optionSelected == AUDIO_BUTTON || type == CUSTOMIZE_FIELD_TYPE_AUDIO
        "
      >
        <template v-for="(fileUpload, index) of fileList" :key="index">
          <input
            v-if="fileUpload.propertyName"
            type="hidden"
            :name="`properties[${fileUpload.propertyName} ${
              fileList.length > 1 ? index + 1 : ''
            }]`"
            :value="'Audio:'"
          />
          <input
            v-if="fileUpload.propertyName"
            type="hidden"
            :name="`properties[${
              attributeKey
                ? attributeKey + CUSTOM_AUDIO_LINK_PREFIX
                : CUSTOM_AUDIO_LINK_PREFIX
            } ${fileUpload.propertyName} ${
              fileList.length > 1 ? index + 1 : ''
            }]`"
            :value="fileUpload.link"
          />
        </template>
      </template>
    </div>
    <div
      v-if="
        type == CUSTOMIZE_FIELD_TYPE_AUDIO_OR_SEARCH_SONG ||
        type == CUSTOMIZE_FIELD_TYPE_SEARCH_SONG
      "
      v-show="optionSelected == SPOTIFY_SONG || optionSelected == YOUTUBE"
    >
      <SearchSpotifySong
        :title="
          type == CUSTOMIZE_FIELD_TYPE_AUDIO_OR_SEARCH_SONG
            ? `${labelSearch || 'Search your song'}`
            : ''
        "
        :class="{
          'search-list-top-sm': type == CUSTOMIZE_FIELD_TYPE_SEARCH_SONG,
        }"
        placeholder="Insert your song"
        :appName="optionSelected == YOUTUBE ? 'youtube' : 'spotify'"
        @change-spotify-song-selected="changeSongSelected"
        @remove-spotify-song-selected="removeSongSelected"
        :required="optionSelected == SPOTIFY_SONG || optionSelected == YOUTUBE"
      >
      </SearchSpotifySong>
      <template
        v-if="optionSelected == SPOTIFY_SONG || optionSelected == YOUTUBE"
      >
        <input
          v-if="songSelected"
          type="hidden"
          :name="`properties[${label}]`"
          :value="`${optionSelected == YOUTUBE ? 'Video: ' : 'Song: '} ${
            songSelected.name
          } - ${songSelected.artist}`"
        />
        <input
          v-if="songSelected"
          type="hidden"
          :name="`properties[${
            optionSelected == YOUTUBE
              ? attributeKey
                ? attributeKey + CUSTOM_VIDEO_LINK_PREFIX
                : CUSTOM_VIDEO_LINK_PREFIX
              : attributeKey
              ? attributeKey + CUSTOM_SONG_LINK_PREFIX
              : CUSTOM_SONG_LINK_PREFIX
          } ${optionSelected == YOUTUBE ? 'Youtube Video: ' : 'Spotify Song'}]`"
          :value="songSelected.uri"
        />
      </template>
    </div>
  </div>
</template>

<script lang="ts" setup>
import FileUpload from '@/ui-kits/FileSelect.vue'
import FileUploadList from '@/ui-kits/FileUploadList.vue'
import SearchSpotifySong from './SearchSpotifySong.vue'
import { ref } from 'vue'
import {
  CUSTOMIZE_FIELD_TYPE_AUDIO,
  CUSTOMIZE_FIELD_TYPE_AUDIO_OR_SEARCH_SONG,
  CUSTOMIZE_FIELD_TYPE_SEARCH_SONG,
  CUSTOM_AUDIO_LINK_PREFIX,
  CUSTOM_SONG_LINK_PREFIX,
  CUSTOM_VIDEO_LINK_PREFIX,
} from '@/utils'

interface Song {
  name: string
  artist: string
  uri: string
}

withDefaults(
  defineProps<{
    id: string
    text?: string
    label?: string
    accept?: string
    multiple?: boolean
    onChange: () => void
    onDelete: () => void
    fileList: {
      file: File
      link?: string
      propertyName: string
      loading?: boolean
    }[]
    type: string
    labelAudio?: string
    labelSearch?: string
    attributeKey?: string
  }>(),
  {
    text: 'Select Audio',
    accept: '.wav,.aif,.aiff,.flac,.alac,.aac,.ogg,.mp3,.m4a,.amr',
    multiple: true,
  }
)
const AUDIO_BUTTON = 'audioButton'
const SPOTIFY_SONG = 'spotifySong'
const YOUTUBE = 'youtube'
const optionSelected = ref(SPOTIFY_SONG)
const options = [
  { label: 'Spotify song', value: SPOTIFY_SONG },
  { label: 'Youtube', value: YOUTUBE },
  { label: 'Your audio', value: AUDIO_BUTTON },
]

const searchOptions = [
  { label: 'Spotify song', value: SPOTIFY_SONG },
  { label: 'Youtube', value: YOUTUBE },
]

const songSelected = ref<Song | null>(null)

function changeOption(value: string) {
  optionSelected.value = value
}
function changeSongSelected(song: Song) {
  songSelected.value = song
}
function removeSongSelected() {
  songSelected.value = null
}
</script>
